var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import HeroGallery from "./heroGallery";
import HeroPhoto from "./heroPhoto";
var Hero = /** @class */ (function (_super) {
    __extends(Hero, _super);
    function Hero() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hero.mapImagesForPhotoGallery = function (images, imageSize) {
        var items = [];
        var height = imageSize.height, width = imageSize.width;
        images.forEach(function (image) {
            var item = {
                h: height,
                src: image + "?fit=crop&w=" + width + "&h=" + height,
                w: width,
            };
            items.push(item);
        });
        return items;
    };
    Hero.Gallery = HeroGallery;
    Hero.Photo = HeroPhoto;
    return Hero;
}(React.Component));
export default Hero;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/hero.tsx
// module id = +ANR
// module chunks = 2